// Свёртка агрегата LedgerTransactions (сгруппированного по direction+isRevert,
// как возвращает backend в extra.totalAmount / GET /ledgerTransactions/stats)
// в понятные плюс/минус/итого. Общий для сводки по счету и по одной транзакции.
export function calculateStatsSummary(stats) {
  const summary = {
    plus: 0,
    minus: 0,
    total: 0
  };
  for (const item of stats || []) {
    if (
      item._id &&
      ["out", "deposit_out"].includes(item._id.direction) &&
      !item._id.isRevert
    ) {
      summary.minus = summary.minus + (item.value + item.comissionAmount);
      summary.total = summary.total - (item.value + item.comissionAmount);
    }
    if (
      item._id &&
      ["out", "deposit_out"].includes(item._id.direction) &&
      item._id.isRevert
    ) {
      summary.minus = summary.minus + (item.value - item.comissionAmount);
      summary.total = summary.total - (item.value - item.comissionAmount);
    }
    if (
      item._id &&
      ["in", "deposit_in"].includes(item._id.direction) &&
      !item._id.isRevert
    ) {
      summary.plus = summary.plus + (item.value - item.comissionAmount);
      summary.total = summary.total + (item.value - item.comissionAmount);
    }
    if (
      item._id &&
      ["in", "deposit_in"].includes(item._id.direction) &&
      item._id.isRevert
    ) {
      summary.plus = summary.plus + (item.value + item.comissionAmount);
      summary.total = summary.total + (item.value + item.comissionAmount);
    }
  }
  return summary;
}



// WEBPACK FOOTER //
// ./src/utils/ledgerStats.js